import { isValidUrl } from './isValidUrl.tsx';

export const getHostnameFromUrl = (url: string): string =>
	isValidUrl(url) ? new URL(url)?.hostname : '';
